module.exports = __webpack_public_path__ + "static/media/taImg3.648313a2.png";